import React from 'react'

const DesktopAgentStep = () => (
  <div className="max-w-[900px]">
    <h2 className="text-lg font-semibold text-black">
      Capture Offline Work &amp; Use the Built-In Clocking Feature
    </h2>
    <p className="mt-3 text-base leading-[1.35] text-[#666]">
      While MIRA captures activities from Microsoft 365 or Google Workspace, the
      Desktop Agent also captures offline work and adds a simple clocking
      feature for manual tracking.
    </p>
    <div className="mt-6 grid grid-cols-2 gap-10">
      <section>
        <h3 className="font-semibold">Why Install Desktop Agent?</h3>
        <ul className="mt-3 space-y-1 text-base text-[#666]">
          <li>✅ Desktop application activity</li>
          <li>✅ Document activity</li>
          <li>✅ Offline work</li>
          <li>✅ Manual clocking events</li>
        </ul>
      </section>
      <section>
        <h3 className="font-semibold">Privacy First</h3>
        <ul className="mt-3 space-y-1 text-base text-[#666]">
          <li>❌ Record keystrokes</li>
          <li>❌ Capture screen contents</li>
          <li>❌ Read document contents</li>
          <li>❌ Monitor communications</li>
        </ul>
      </section>
    </div>
  </div>
)

export default DesktopAgentStep
